import { EWidgetType } from '@/_enums/utils'
import { commonService } from '../../_services'
const widgetSettingService = commonService('api/v1/admin/widget-setting')

export const widgets = {
  namespaced: true,
  state: {
    all: { items: [] },
    loading: false
  },
  actions: {
    async getAll(context: any): Promise<void> {
      context.commit('SET_LOADING')

      return commonService('api/v1/widget-setting')
        .getAll({ unit_id: context.rootState.units?.item?._id, type: EWidgetType.unit_setting })
        .then(resp => {
          context.commit('GET_ALL_SUCCESS', resp.data)
        })
        .catch(errorMsg => {
          context.commit('GET_ALL_FAILURE')
          context.dispatch(
            'common/setFlashMessage',
            { error: [errorMsg] },
            { root: true }
          )
        })
    },
    async addOne(context: any, data: any): Promise<void> {
      context.commit('SET_LOADING')

      return widgetSettingService
        .addOne({...data, unit_id: context.rootState.units?.item?._id})
        .then(resp => {
          context.commit('ADD_ITEM_SUCCESS', resp.data)
          return Promise.resolve(resp.data)
        })
        .catch(errorMsg => {
          context.commit('REQUEST_ERROR')
          context.dispatch(
            'common/setFlashMessage',
            { error: [errorMsg] },
            { root: true }
          )
          return Promise.reject(errorMsg)
        })
    },
    async updateOne(context: any, data: any): Promise<void> {
      context.commit('SET_LOADING')

      return widgetSettingService
        .updateOne({...data, unit_id: context.rootState.units?.item?._id})
        .then(resp => {
          context.commit('UPDATE_ITEM_SUCCESS', data)
          return Promise.resolve(resp.data)
        })
        .catch(errorMsg => {
          context.commit('REQUEST_ERROR')
          context.dispatch(
            'common/setFlashMessage',
            { error: [errorMsg] },
            { root: true }
          )
          return Promise.reject(errorMsg)
        })
    },
    async reOrderItems(context: any, data: any): Promise<void>{
      context.commit('SET_LOADING')

      return commonService('api/v1/admin/widget-setting/re-order').postData(data)
        .then(resp => {
          context.commit('RE_ORDER_ITEMS_SUCCESS', resp.data)
          return Promise.resolve(resp.data)
        })
        .catch(errorMsg => {
          context.commit('REQUEST_ERROR')
          context.dispatch(
            'common/setFlashMessage',
            { error: [errorMsg] },
            { root: true }
          )
          return Promise.reject(errorMsg)
        })
    },
    async deleteOne(context: any, id: any): Promise<void> {
      context.commit('SET_LOADING')
      return widgetSettingService
        .deleteOne(id)
        .then(resp => {
          context.commit('DELETE_ITEM_SUCCESS', id)
          return Promise.resolve(resp.data)
        })
        .catch(errorMsg => {
          context.commit('REQUEST_ERROR')
          context.dispatch(
            'common/setFlashMessage',
            { error: [errorMsg] },
            { root: true }
          )
          return Promise.reject(errorMsg)
        })
    }
  },
  mutations: {
    SET_LOADING(state: any) {
      state.loading = true
    },
    GET_ALL_SUCCESS(state: any, allItems: any[]) {
      allItems.map(item => {
        return item
      })

      state.all = { items: allItems }
      state.loading = false
    },
    GET_ALL_FAILURE(state: any) {
      state.all = { items: [] }
      state.loading = false
    },
    ADD_ITEM_SUCCESS(state: any, item: any) {
      state.all.items.push(item)
      state.loading = false
    },
    UPDATE_ITEM_SUCCESS(state: any, item: any) {
      state.all.items = state.all.items.map(tmp => {
        return tmp._id === item._id ? item : tmp
      })

      state.loading = false
    },
    RE_ORDER_ITEMS_SUCCESS(state: any, data: any) {
      const { toData, fromData } = data

      state.all.items = state.all.items.map((elem) => {
        if (elem._id === toData._id) {
          return fromData
        }

        if (elem._id === fromData._id) {
          return toData
        }

        return elem
      })

      state.loading = false
    },
    DELETE_ITEM_SUCCESS(state: any, id: string) {
      const index = state.all.items.findIndex(item => item._id === id)
      if (index > -1) {
        state.all.items.splice(index, 1)
      }
      state.loading = false
    },
    REQUEST_ERROR(state: any) {
      state.loading = false
    }
  },
  getters: {
    canEdit: state => () => {
      return widgetSettingService.canEdit()
    },
    canDelete: state => () => {
      return widgetSettingService.canDelete()
    },
    isWidgetLoading: (state: any) => {
      return state.loading
    }
  }
}
